import * as Utils from "../libraries/utils";

const CategoryHelper = {
	findCategory: (self, productId) => {
		const shopId = self.$store.getters.globalSelectedShop.id;
		const productCatalog = self.$store.getters.productCatalog;
		const categories = Utils.getCategoriesByShopId(
			shopId,
			productCatalog
		);
		const res = categories.find((cat) => {
			return (
				cat.elements.find((element) => {
					if (element.objType === "GridBlockElement") {
						return (
							element.items.find((product) => product.id === productId) !== undefined
						);
					} else if (element.props && element.props.products) {
						return (
							element.props.products.find((product) => product === productId) !== undefined
						);
					} else {
						return false;
					}
				}) !== undefined
			);
		});

		return res;
	}
};

export default CategoryHelper;